import script from "./ExternalNotarization.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExternalNotarization.vue?vue&type=script&lang=ts&setup=true"

import "./ExternalNotarization.vue?vue&type=style&index=0&id=cc7e04ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc7e04ae"]])

export default __exports__